/* eslint-disable react/no-array-index-key */
import React from "react";
import { NavLink } from "react-router-dom";
import { Badge, Button, Card, CardBody } from "reactstrap";

const PriceCard = ({
  isCurrentPlan,
  data,
  recommended,
  onPurchase,
  subscriptionType,
}) => {
  const {
    features: { pricingTable },
  } = data;
  let classNames = 'price-card';
  if (isCurrentPlan) {
    classNames += ' current';
  }
  if (recommended) {
    classNames += ' active';
  }
  return (
    <Card
      className={classNames}
    >
      {recommended && (
        <Badge
          color="primary"
          style={{
            position: "absolute",
            borderRadius: "20px",
            fontSize: "12px",
            padding: "8px",
            top: "-10px",
            right: "-10px",
          }}
        >
          Recommended
        </Badge>
      )}
      {isCurrentPlan && (
        <Badge
          color="primary"
          style={{
            position: "absolute",
            borderRadius: "20px",
            fontSize: "12px",
            padding: "8px",
            top: "-10px",
            left: "-10px",
          }}
        >
          Your Plan
        </Badge>
      )}
      <CardBody className="pt-5 pb-5 d-flex flex-column align-items-center">
        <div className="price-top-part">
          <i className={`large-icon ${data.icon}`} />
          <h5 className="mb-0 font-weight-semibold color-theme-1 mb-4">
            {data.title}
          </h5>
          <p className="text-large mb-2 text-default">
            <span style={{ fontSize: '1.5rem' }} className="mr-1 text-muted">
              <del>
                {data.oldPrice}
              </del>
            </span>
            {data.price}
          </p>
          <p className="text-muted text-small">{subscriptionType}</p>
        </div>
        <div className="pl-3 pr-3 pt-3 pb-0 d-flex price-feature-list flex-column flex-grow-1">
          <div>
            <ul className="list-unstyled mb-0">
              {pricingTable?.length > 0 &&
                pricingTable.map((p, i) => (
                  <li key={i}>
                    <p className="mb-0">{p.description}</p>
                  </li>
                ))}
            </ul>
          </div>
          {!isCurrentPlan && (
            <div className="text-center">
              <Button
                color="primary"
                className="p-2"
                onClick={() => onPurchase(data)}
              >
                Change Plan
              </Button>
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default React.memo(PriceCard);
